import React, { useEffect, useState } from "react";
import { ShieldCheck, Star } from "lucide-react";
import api from "@/lib/api";
import { optimizeImageUrl, responsiveWidth } from "@/lib/imageUtils";

const DEFAULT_IMAGE = "https://images.pexels.com/photos/18341554/pexels-photo-18341554.jpeg";
const DEFAULT_TITLE = "Your Gateway to Gulf Visa & Travel Services";
const DEFAULT_SUBTITLE = "GAMCA appointments, VFS bookings, dummy tickets & immigration services - fast, secure, and trusted across India. Book in minutes, track anytime.";

export default function Hero() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/site-settings").then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  const hero = settings?.homepage_content?.hero || {};
  const title = settings?.hero_title || DEFAULT_TITLE;
  const image = settings?.hero_image || DEFAULT_IMAGE;

  return (
    <section data-testid="home-hero" className="relative min-h-[46vh] sm:min-h-[78vh] lg:min-h-[90vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={optimizeImageUrl(image, responsiveWidth(1600))}
          alt="Dubai skyline"
          fetchPriority="high"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-24 w-full">
        <div className="max-w-2xl animate-fade-in-up">
          <span data-testid="hero-badge-text" className="overline text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)] bg-white/10 px-4 py-2 rounded-full inline-block backdrop-blur-sm">
            {hero.badge_text || "Trusted by 25,000+ Customers"}
          </span>
          <h1 data-testid="hero-title" className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight font-bold text-white mt-4 sm:mt-6">
            {title}
          </h1>
          <p data-testid="hero-subtitle" className="text-base sm:text-lg text-gray-200 mt-3 sm:mt-6 leading-relaxed max-w-xl">
            {settings?.hero_subtitle || DEFAULT_SUBTITLE}
          </p>
          <div className="flex items-center gap-6 mt-5 sm:mt-8 text-white">
            <div className="flex items-center gap-2">
              <ShieldCheck size={20} className="text-[var(--brand-primary)]" />
              <span data-testid="hero-trust-line-1" className="text-sm">{hero.trust_line_1 || "100% Secure Payments"}</span>
            </div>
            <div className="flex items-center gap-2">
              <Star size={20} className="text-[var(--brand-primary)]" fill="var(--brand-primary)" />
              <span data-testid="hero-trust-line-2" className="text-sm">{hero.trust_line_2 || "4.9/5 Google Rating"}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
